import { Grid, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const SearchResultList = ({ header, list }) => {
    const handleNavigate = (url) => {
        window.location.href = url;
    };

    return (
        <Grid container spacing={1} sx={{ px: 2, py: 1.2 }}>
            <Grid item xs={12}>
                <Typography variant="subtitle1">{header}</Typography>
            </Grid>
            {list?.map((menu, i) => (
                <Grid item key={i}>
                    <Tooltip placement="bottom" title={`Click to go to ${menu?.title || ''}`}>
                        <Typography
                            variant="body"
                            sx={{
                                color: '#2da8de',
                                textDecoration: 'underline',
                                cursor: 'pointer'
                            }}
                            onClick={() => handleNavigate(menu?.url || '')}
                        >
                            {menu?.title || ''}
                        </Typography>
                    </Tooltip>
                </Grid>
            ))}
        </Grid>
    );
};

SearchResultList.propTypes = {
    header: PropTypes.string,
    list: PropTypes.array
};

export default SearchResultList;
